var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{class:_vm.sizeClasses,attrs:{"data-v-step":"3"},on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{staticClass:"e-assets-slider",attrs:{"title":"My Assets"}},[_c('eb-my-assets')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"My Events (Soon)","disabled":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d46e6d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/assets/assets.vue
// module id = Hp1D
// module chunks = 22